module.exports = __webpack_public_path__ + "img/news_page_boy_article.8bafdbda.png";